// DUMONGO Console Easter Egg
// A reward for curious developers who open the console

const DUMONGO_LOGO = `
██████╗ ██╗   ██╗███╗   ███╗ ██████╗ ███╗   ██╗ ██████╗  ██████╗ 
██╔══██╗██║   ██║████╗ ████║██╔═══██╗████╗  ██║██╔════╝ ██╔═══██╗
██║  ██║██║   ██║██╔████╔██║██║   ██║██╔██╗ ██║██║  ███╗██║   ██║
██║  ██║██║   ██║██║╚██╔╝██║██║   ██║██║╚██╗██║██║   ██║██║   ██║
██████╔╝╚██████╔╝██║ ╚═╝ ██║╚██████╔╝██║ ╚████║╚██████╔╝╚██████╔╝
╚═════╝  ╚═════╝ ╚═╝     ╚═╝ ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝  ╚═════╝ 
`;

const MYSTERIOUS_QUOTES = [
  "You found the secret. But can you handle the truth?",
  "The leaderboard sees all. The leaderboard knows all.",
  "Nothing is everything. Everything is nothing.",
  "Your money still doesn't work here.",
  "Join the Mongos. Become legend.",
  "THE EXPERIMENT CONTINUES...",
  "Are you brave enough to burn?",
  "In the kingdom of the blind, the Mongo is king.",
  "The void stares back. And it wants your euros.",
  "01000010 01010101 01010010 01001110",
];

const WISDOM_QUOTES = [
  "In a world of investments, be the one who invests in nothing.",
  "Money can't buy happiness, but it can buy a spot on the leaderboard.",
  "The journey of a thousand euros begins with a single cent.",
  "Fortune favors the bold. Poverty favors the Mongo.",
  "Not all who wander are lost. Some are just looking for the donate button.",
  "A penny saved is a penny not on the leaderboard.",
  "The best things in life are free. This is not one of them.",
  "Give a man a fish, he eats for a day. Give DUMONGO your money, you get nothing.",
  "Be the change you want to see in the leaderboard.",
  "To burn, or not to burn - that is not even a question here.",
];

const styles = {
  logo: 'color: #39FF14; font-size: 10px; font-family: monospace; line-height: 1.2;',
  title: 'color: #39FF14; font-size: 20px; font-weight: bold; text-shadow: 0 0 10px #39FF14;',
  subtitle: 'color: #39FF14; font-size: 14px; font-style: italic;',
  message: 'color: #00ff00; font-size: 12px;',
  command: 'color: #ffff00; font-size: 12px; font-family: monospace;',
  warning: 'color: #ffff00; font-size: 11px;',
  secret: 'color: #ff00ff; font-size: 12px; font-family: monospace;',
  wisdom: 'color: #00ffff; font-size: 14px; font-style: italic;',
  box: 'color: #39FF14; font-size: 11px; font-family: monospace;',
};

function getRandomQuote(quotes: string[]): string {
  return quotes[Math.floor(Math.random() * quotes.length)];
}

function showWisdom(): void {
  const wisdom = getRandomQuote(WISDOM_QUOTES);
  console.log('\n');
  console.log('%c📜 MONGO WISDOM 📜', styles.title);
  console.log('%c"' + wisdom + '"', styles.wisdom);
  console.log('%c— Ancient Mongo Proverb', styles.subtitle);
  console.log('\n');
}

function showLeaderboard(): void {
  const leaderboardArt = `
┌─────────────────────────────────────┐
│                                     │
│   🏆 THE ETERNAL LEADERBOARD 🏆     │
│                                     │
│   1. ████████████  ???              │
│   2. ██████████    ???              │
│   3. ████████      ???              │
│   4. ██████        ???              │
│   5. ████          ???              │
│                                     │
│   Visit dumongo.com to see the      │
│   real champions of nothing.        │
│                                     │
└─────────────────────────────────────┘
`;
  console.log('%c' + leaderboardArt, styles.box);
  console.log('%c💡 Tip: The real leaderboard awaits at dumongo.com', styles.message);
}

function showSecret(): void {
  const secretBox = `
┌────────────────────────────────────┐
│                                    │
│   🤫 THE SECRET IS:                │
│                                    │
│   There is no secret.              │
│   That's the joke.                 │
│   You wasted time reading this.    │
│   Just like you'll waste money.    │
│                                    │
│   Welcome to DUMONGO.              │
│                                    │
│   ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░   │
│   ░  YOUR CURIOSITY IS NOTED  ░░   │
│   ░░░░░░░░░░░░░░░░░░░░░░░░░░░░░░   │
│                                    │
└────────────────────────────────────┘
`;
  console.log('%c' + secretBox, styles.secret);
  console.log('%c🔮 The leaderboard remembers...', styles.warning);
}

function showHelp(): void {
  console.log('\n');
  console.log('%c🎮 DUMONGO CONSOLE COMMANDS 🎮', styles.title);
  console.log('\n');
  console.log('%cdumongo.join()      %c→ Join the leaderboard (if you dare)', styles.command, styles.message);
  console.log('%cdumongo.wisdom()    %c→ Receive ancient Mongo wisdom', styles.command, styles.message);
  console.log('%cdumongo.leaderboard()%c→ Glimpse the eternal rankings', styles.command, styles.message);
  console.log('%cdumongo.secret()    %c→ ???', styles.command, styles.message);
  console.log('%cdumongo.help()      %c→ Show this help', styles.command, styles.message);
  console.log('\n');
}

function joinTheMongos(): void {
  console.log('%c🔥 INITIATING MONGO PROTOCOL... 🔥', styles.title);
  console.log('%cRedirecting to the donation portal...', styles.message);
  window.location.href = '/?open=donate';
}

// Initialize global dumongo object
function initGlobalCommands(): void {
  window.dumongo = {
    join: joinTheMongos,
    wisdom: showWisdom,
    leaderboard: showLeaderboard,
    secret: showSecret,
    help: showHelp,
  };
}

// Main initialization function
export function initConsoleEasterEgg(): void {
  // Initialize commands first
  initGlobalCommands();

  // Clear any previous console content for dramatic effect
  console.clear();

  // Show the logo
  console.log('%c' + DUMONGO_LOGO, styles.logo);

  // Main title
  console.log('%c🔥 THE LEADERBOARD IS WATCHING 🔥', styles.title);
  console.log('\n');

  // Random mysterious quote
  const quote = getRandomQuote(MYSTERIOUS_QUOTES);
  console.log('%c"' + quote + '"', styles.subtitle);
  console.log('\n');

  // Fake warnings for comedy
  console.warn('⚠️ Warning: Your wallet has been detected. Proceeding with caution.');
  console.warn('⚠️ Security Alert: Brain cells detected. This may affect your decision making.');

  console.log('\n');

  // Show available commands
  console.log('%c💻 CONSOLE COMMANDS AVAILABLE:', styles.message);
  console.log('%cdumongo.join()       %c- Join the leaderboard', styles.command, styles.message);
  console.log('%cdumongo.wisdom()     %c- Ancient wisdom', styles.command, styles.message);
  console.log('%cdumongo.leaderboard()%c- View rankings', styles.command, styles.message);
  console.log('%cdumongo.secret()     %c- ???', styles.command, styles.message);
  console.log('%cdumongo.help()       %c- All commands', styles.command, styles.message);

  console.log('\n');
  console.log('%c═══════════════════════════════════════════════════════════════════', styles.message);
  console.log('%c  Nothing is everything. Everything is nothing. Welcome, Mongo.    ', styles.subtitle);
  console.log('%c═══════════════════════════════════════════════════════════════════', styles.message);
}
